
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { api } from '../config';

const httpLink = createHttpLink({
  uri: api.graphql,
});

const client = new ApolloClient({
  // link: authLink.concat(httpLink),
  link: httpLink,
  cache: new InMemoryCache({
    addTypename: false
  })
});
export default client;
